export {WhatIs as Page};

import {Helmet} from "react-helmet-async";
import messages from "../../messages/messages.js";

function WhatIs() {
    return (
        <section>

            <Helmet>
                <title>{messages["META.WHAT_IS.TITLE"]}</title>
                <meta name="description" content={messages["META.WHAT_IS.DESC"]}/>
            </Helmet>

            <div>
                <img alt={messages["WHAT_IS.IMAGE_ALT"]} className="rounded-lg mb-5"
                     src={`/img/${messages["WHAT_IS.IMAGE"]}`}/>

                <h1>What is {messages["SITE.NAME"]}?</h1>

                <div dangerouslySetInnerHTML={{__html: messages["WHAT_IS.DESC"]}}/>
            </div>
        </section>
    );
}
